<template lang='pug'>
.container
  .container
    .row.mt-5.align-items-center
      .col-12.my-header.font-weight-bold
        //- | Интеграция системы учёта

  .container.mt-5
    .white_block
      .connection(v-if="connecting")
        h2 Интеграция системы
        .loading(v-show="connection_status=='loading'") 
          .loader_holder
            object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
        .done(v-show="connection_status=='done'") 
          .row
            .col-3.icon
              i.fad.fa-check
            .col
              h2 Успех!
              .text Поздравляем! Интеграция со системой прошла успешно и теперь Вы можете приступать к работе вместе с нами.
              br
              router-link.styled(to="/marketplace") Перейти в Маркетплейс
        .fail(v-show="connection_status=='fail'")
          .row
            .col-3.icon
              i.fad.fa-times
            .col
              h2 Усп! Ошибка!
              .text Пожалуйста, попробуйте ещё один раз. Если ничего не получится, пишите нам в чат!
              br
              a.styled(href="/account/new_pos_auth") Еще раз

      <form-wizard v-if="!connecting" @on-complete="wizardComplete" @on-validate="handleValidation">
        <tab-content title="Система учёта" v-if="!tabs.pos_system.hide" :before-change="validateSelectedPos">
          | Пожалуйста, выберите систему учёта, на которой работает Ваше заведение:
          br
          br
          input-module(
            type="select",
            title="Система учёта",
            v-model="information.pos_system",
            :values="[ { value: '-', name: '' }, { value: 'POSTER', name: 'Poster' }, { value: 'IIKO', name: 'iiko' }, { value: 'RKEEPER', name: 'R-Keeper' }, { value: 'other', name: 'Другая' }, ]",
            valueKey="value",
            valueName="name",
            @change="pos_system_select"
          )
          //- select(v-model="information.pos_system" @change="pos_system_select")
          //-   option(value="-") 
          //-   option(value="POSTER") Poster
          //-   option(value="IIKO") IIKO (Айко)
          //-   option(value="RKEEPER") R-Keeper
          //-   option(value="QUICKRESTO") QuickResto
          //-   option(value="HOOKAHWORK") HookahWork
          //-   option(value="YCLIENTS") YCLIENTS
          //-   option(value="other") Другая
        </tab-content>
        <tab-content title="Подключение к Poster" v-if="!tabs.poster_auth.hide" :before-change="validatePoster">
          | Отлично, теперь нам необходимо связаться с Вашим Постером.
          br
          br
          | У нас есть собственное приложение в Магазине Приложений Poster, его просто нужно установить в систему.
          br
          | Для установки Вам потребуется:
          ul
            li Веб-интерфейс панели управления Poster
            li Права доступа "Владелец"
          | Если всё есть, давайте начнём! Нажимайте Подключить.
          br
          .connect
            span.fal.fa-long-arrow-alt-right.arrow
            a(href="https://joinposter.com/applications/actidhub") 
              button.styled Подключить
          br
          br
        </tab-content>
        <tab-content title="Подключение" v-if="!tabs.contacts_collect.hide" :before-change="validateContacts">
          | К сожалению, мы пока не научились автоматически подключаться к {{ information.pos_system }}...
          br
          | Но это всё-равно нам не помешает провести интеграцию! За дело возьмется наш специалист.
          br
          br
          | Подскажите, пожалуйста, с кем можно связаться по вопросу интеграции с Вашим заведением?
          br
          br
          input-module(
            type="text",
            v-model="information.contacts.name",
            title="Ваше имя"
          )
          //- label Имя: 
          //- input(type="text" v-model="information.contacts.name")
          br
          input-module(
            type="text",
            v-model="information.contacts.phone",
            title="Ваш номер телефона"
          )
          //- label Номер телефона: 
          //- input(type="tel" v-model="information.contacts.phone")
          br
          input-module(
            type="select",
            v-model="information.contacts.contact_by",
            title="Наилучший способ связи",
            :values="[ { value: 'telegram', name: 'Телеграм' }, { value: 'whatsapp', name: 'WhatsApp' }, { value: 'viber', name: 'Viber' }, { value: 'phone', name: 'По телефону' }, ]",
            valueKey="value",
            valueName="name"
          )

          //- label Наилучший способ связи: 
          //- select( v-model="information.contacts.contact_by")
          //-   option(value="telegram") Телеграм
          //-   option(value="whatsapp") WhatsApp
          //-   option(value="viber") Viber
          //-   option(value="phone") По телефону
        </tab-content>
        <tab-content title="Готово" v-if="!tabs.manual_wait.hide">
          h2 Отлично!
          | В ближайшее время мы свяжемся с Вами, и расскажем каким способом проходит интеграция.
          br
        </tab-content>
        <tab-content title="Готово" v-if="!tabs.done.hide">
          h2 Отлично!
          | Интеграция прошла успешно!
          br
        </tab-content>
      </form-wizard>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
var apiDriver = require("../../apiDriver").default;

import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

// console.log(FormWizard.props);
FormWizard.props.title.default = "Интеграция системы учёта";
FormWizard.props.subtitle.default = "";
FormWizard.props.color.default = "rgb(108, 104, 203)";
FormWizard.props.finishButtonText.default = "Готово";
FormWizard.props.backButtonText.default = "Назад";
FormWizard.props.nextButtonText.default = "Дальше";

export default {
  data() {
    return {
      connecting: false,
      connection_status: "loading",
      tabs: {
        pos_system: { hide: false }, // ok
        poster_auth: { hide: true }, // ok
        contacts_collect: { hide: false }, // ok
        done: { hide: true }, // ok
        manual_wait: { hide: false }, // ok
      },
      information: {
        pos_system: "-",
        contacts: {
          name: "",
          phone: "",
          contact_by: "telegram",
        },
      },
    };
  },

  computed: {},

  mounted() {
    this.checkConnectionQuery();
    this.loadContacts();
  },

  methods: {
    async checkConnectionQuery() {
      var url = new URL(document.location.href);
      var connection_token = url.searchParams.get("connectwith");
      if (!connection_token) return;
      this.connecting = true;
      this.connection_status = "loading";
      var c = await apiDriver.connections.connect_token(connection_token);
      if (connection_token == "done") return (this.connection_status = "done");
      if (connection_token == "fail") return (this.connection_status = "fail");
      if (connection_token == "loading")
        return (this.connection_status = "loading");
      if (c) {
        this.connection_status = "done";
      } else {
        this.connection_status = "fail";
      }
    },

    async loadContacts() {
      var user = await apiDriver.user();
      console.log("user->", user);
      this.information.contacts.name = user.name;
      this.information.contacts.phone = user.phone;
    },

    handleValidation: function (isValid, tabIndex) {
      console.log("Tab: " + tabIndex + " valid: " + isValid);
    },
    wizardComplete() {
      console.log("wizardComplete!");
    },
    pos_system_select() {
      console.log(this.information.pos_system);
      if (this.information.pos_system == "POSTER") {
        this.tabs.poster_auth.hide = false;
        this.tabs.done.hide = false;
        this.tabs.manual_wait.hide = true;
        this.tabs.contacts_collect.hide = true;
      } else {
        this.tabs.poster_auth.hide = true;
        this.tabs.done.hide = true;
        this.tabs.manual_wait.hide = false;
        this.tabs.contacts_collect.hide = false;
      }
    },
    validatePoster() {
      console.log("validatePoster...");
      return new Promise(function (resolve, reject) {
        reject(false);
        // resolve(true);
      });
    },
    validateSelectedPos() {
      console.log("validateSelectedPos...");
      if (this.information.pos_system == "-") {
        return false;
      } else {
        return true;
      }
    },
    validateContacts() {
      console.log("validateContacts...");
      return new Promise(async (resolve, reject) => {
        this.information.contacts.name = this.information.contacts.name.replace(
          / /g,
          ""
        );
        this.information.contacts.phone =
          this.information.contacts.phone.replace(/ /g, "");
        var name = this.information.contacts.name;
        var phone = this.information.contacts.phone;
        var pos_system = this.information.pos_system;
        var contact_by = this.information.contacts.contact_by;
        console.log("name", name, name.length, "phone", phone, phone.length);
        if (!name) return reject("name");
        if (!phone) return reject("phone");
        if (name.length <= 2) return reject("name");
        if (phone.length <= 9) return reject("phone");

        var added = await apiDriver.connections.add_ticket(
          name,
          phone,
          pos_system,
          contact_by
        );

        window.ChatConnect.chatStorage.main_account_chat.sendTextMessage(
          "Здравствуйте, я оформил заявку на интеграцию с " +
            pos_system +
            ".\n" +
            name +
            ", " +
            phone +
            ".\nПрошу связаться со мой по " +
            contact_by +
            "."
        );

        console.log("added:", added);

        if (added.done) {
          return resolve(true);
        } else {
          swal({
            title: "Ошибка",
            text: "К сожалению, Вы достигли лимита заявок на сегодня. Пожалуйста, попробуйте позже.",
            type: "error",
          });
          return reject("server_error");
        }
      });
    },
  },

  components: {
    FormWizard,
    TabContent,
  },
};
</script>
<style scoped lang="stylus">
.white_block {
  background: white;
  margin: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 7px;
}

.my-header {
  font-size: 3.5rem;
}

.header-sub {
  // color: white;
  font-size: 1.5rem;
}

.wizard-title {
  margin-bottom: 20px;
}

.wizard-tab-content {
  label {
    margin-right: 5px;
  }
}

.wizard-tab-container {
  margin-bottom: 50px;
}

.connect {
  margin-top: 20px;

  .arrow {
    font-size: 30px;
    margin-right: 10px;
    color: #6c68cb;
    position: relative;
    top: 5px;
  }
}

.connection {
  margin-bottom: 30px;

  .icon {
    font-size: 120px;
    text-align: center;
    color: #7687e0;
  }

  .loader_holder {
    text-align: center;
  }
}
</style>
